import { createContext, useContext } from 'react'

export const PersonalAreaContext = createContext(undefined)

export const usePersonalAreaContext = () => useContext(PersonalAreaContext)
